export const sliderData2 = [
    {
      image: "/img/events/space-quiz7.jpeg",
      // heading: "Slide One",
      // desc: "This is the description of slide one Lorem ipsum dolor, sit amet consectetur adipisicing elit. Modi quos quas, voluptatum nesciunt illum exercitationem.",
    },
    {
      image: "/img/events/space-quiz2.jpeg",
      // heading: "Slide Two",
      // desc: "This is the description of slide two Lorem ipsum dolor, sit amet consectetur adipisicing elit. Modi quos quas, voluptatum nesciunt illum exercitationem.",
    },
    {
      image: "/img/events/space-quiz6.jpeg",
      // heading: "Slide Three",
      // desc: "This is the description of slide three Lorem ipsum dolor, sit amet consectetur adipisicing elit. Modi quos quas, voluptatum nesciunt illum exercitationem.",
    },
  ];